import { render, staticRenderFns } from "./NuevoTicket.vue?vue&type=template&id=4253d26e"
import script from "./NuevoTicket.vue?vue&type=script&lang=js"
export * from "./NuevoTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports